import React, { Component } from 'react';
import Page from '../pages/Page';
import DraftEditContainer from '../containers/DraftEdit';
import { injectIntl } from 'react-intl';

class DraftEdit extends Component {
  getMetaData() {
    return {
      title: this.pageTitle(),
      meta: this.pageMeta(),
      link: this.pageLink()
    };
  }

  pageTitle = () => {
    return this.props.intl.formatMessage({id: 'draftEdit.pageTitle'});
  };

  pageMeta = () => {
    return [
      { name: 'description', content: this.props.intl.formatMessage({id: 'draftEdit.pageDescription'}) }
    ];
  };

  pageLink = () => {
    return [];
  };

  render() {
    return (
      <Page {...this.getMetaData()}>
        <DraftEditContainer {...this.props} />
      </Page>
    );
  }
}

export default injectIntl(DraftEdit);



// WEBPACK FOOTER //
// app/pages/DraftEdit.jsx